import { render, staticRenderFns } from "./device-reset-requests.vue?vue&type=template&id=597d8708"
import script from "./device-reset-requests.vue?vue&type=script&lang=js"
export * from "./device-reset-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports